<div *ngIf="templateOptions.sectionList$ | async; let sectionList" class="account-info">
    <div *ngFor="let section of sectionList"
         class="account-info__section"
         [mmTestId]="section.testId">
        <div [ngSwitch]="section.template" class="account-info__section-column">
            <ng-container *ngSwitchCase="'private-info'">
                <ng-container
                    *ngTemplateOutlet="privateInfoSectionTemplate; context: { section: section }"
                ></ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="'business-info'">
                <ng-container
                    *ngTemplateOutlet="businessInfoSectionTemplate; context: { section: section }"
                ></ng-container>
            </ng-container>

            <ng-container *ngSwitchDefault>
                <ng-container
                    *ngTemplateOutlet="baseSectionTemplate; context: { section: section }"
                ></ng-container>
            </ng-container>
        </div>
        <div class="account-info__section-column"
             [class.account-info__section-column--align-with-center]="section.linkAlignment === 'center'">
            <a *ngIf="section.link"
               class="account-info__section-link"
               [routerLink]="section.link"
               [mmTestTarget]="'action-link'">
            <span *appHideFor="'mm-mobile'">
               {{ section.linkText | translate }}
            </span>
                <mm-icon *appShowFor="'mm-mobile'" name="edit-small"></mm-icon>
            </a>
        </div>
    </div>
</div>

<ng-template #baseSectionTemplate let-section="section">
    <div class="account-info__section-title">{{ section.title | translate }}:</div>
    <div class="account-info__section-description" [mmTestTarget]="'content'">
        {{ section.content || (section.translation | translate) }}
    </div>
</ng-template>

<ng-template #businessInfoSectionTemplate let-section="section">
    <div class="business-info" *ngIf="section.data; let data">
        <div class="business-info__group">
            <div class="business-info__title">{{ 'REGULAR.BUSINESS_INFO' | translate }}:</div>
            <div class="business-info__content">
                <div [mmTestTarget]="'company-name'">{{data.companyName}}</div>
                <div *ngIf="data.vatNumber">
                    {{ 'REGULAR.VAT_NUMBER' | translate }}:
                    <span [mmTestTarget]="'vat-number'">{{ data.vatNumber }}</span>
                </div>
                <div *ngIf="data.taxNumber">
                    {{ 'REGULAR.TAX_NUMBER' | translate }}:
                    <span [mmTestTarget]="'tax-number'">{{ data.taxNumber }}</span>
                </div>
                <div>
                    <span [mmTestTarget]="'street'">{{ data.street }}</span>
                    <span *ngIf="data.street && data.houseNumber">, </span>
                    <span [mmTestTarget]="'house-number'">{{data.houseNumber }}</span>
                </div>
                <div [mmTestTarget]="'address-line-2'">{{ data.addressLine2 }}</div>
                <div>
                    <span [mmTestTarget]="'postal-code'">{{ data.postalCode }}</span>
                    <span *ngIf="data.city && data.postalCode">&nbsp;</span>
                    <span [mmTestTarget]="'city'">{{ data.city }}</span>
                </div>
                <div [mmTestTarget]="'country'">{{ data.country }}</div>
            </div>
        </div>
        <div class="business-info__group">
            <div class="business-info__title">{{ 'REGULAR.CONTACT_PERSON' | translate }}:</div>
            <div class="business-info__content">
                <div>
                    <span [mmTestTarget]="'first-name'">
                        {{ data.firstName }}
                    </span> <span [mmTestTarget]="'last-name'">
                        {{ data.lastName }}
                    </span>
                </div>
                <div [mmTestTarget]="'phone'">{{ data.phone }}</div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #privateInfoSectionTemplate let-section="section">
    <div class="private-info__title">{{ 'PAGES.ACCOUNT.INFO.PRIVATE_INFO' | translate }}:</div>
    <div *ngIf="section.data; let data" class="private-info__content">
        <span [mmTestTarget]="'first-name'">
            {{ data.firstName }}
        </span> <span [mmTestTarget]="'last-name'">
            {{ data.lastName }}
        </span>
    </div>
</ng-template>
